[
    {
        "ID": 101,
        "NAME": "brand",
        "OEM_ID": 1
    },
    {
        "ID": 102,
        "NAME": "model",
        "OEM_ID": 1
    },
    {
        "ID": 103,
        "NAME": "navigation_system",
        "OEM_ID": 1
    },
    {
        "ID": 201,
        "NAME": "model",
        "OEM_ID": 2
    },
    {
        "ID": 202,
        "NAME": "series",
        "OEM_ID": 2
    },
    {
        "ID": 203,
        "NAME": "year",
        "OEM_ID": 2
    },
    {
        "ID": 301,
        "NAME": "vehicle",
        "OEM_ID": 3
    },
    {
        "ID": 401,
        "NAME": "model",
        "OEM_ID": 4
    },
    {
        "ID": 402,
        "NAME": "region",
        "OEM_ID": 4
    },
    {
        "ID": 501,
        "NAME": "country_code",
        "OEM_ID": 5
    },
    {
        "ID": 502,
        "NAME": "series_number",
        "OEM_ID": 5
    },
    {
        "ID": 601,
        "NAME": "model",
        "OEM_ID": 6
    },
    {
        "ID": 602,
        "NAME": "navigation_system",
        "OEM_ID": 6
    }
]